import React, {useState, useEffect} from 'react'
import {KTIcon} from '../../../../_metronic/helpers'
import {Funcionalidad} from '../core/models'

type Props = {
  selectedFuncionalidades: number[]
  availableFuncionalidades: Funcionalidad[]
  loading: boolean
  onChange: (funcionalidadIds: number[]) => void
}

const FuncionalidadesSelector: React.FC<Props> = ({
  selectedFuncionalidades,
  availableFuncionalidades,
  loading,
  onChange,
}) => {
  const [funcionalidadesCache, setFuncionalidadesCache] = useState<Map<number, Funcionalidad>>(
    new Map()
  )

  // Actualizar el cache con las nuevas funcionalidades disponibles
  useEffect(() => {
    setFuncionalidadesCache((prevCache) => {
      const newCache = new Map(prevCache)
      availableFuncionalidades.forEach((func) => {
        if (!newCache.has(func.id)) {
          newCache.set(func.id, func)
        }
      })
      return newCache
    })
  }, [availableFuncionalidades])

  const handleSelectFuncionalidad = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const funcionalidadId = parseInt(e.target.value)
    if (funcionalidadId && !selectedFuncionalidades.includes(funcionalidadId)) {
      onChange([...selectedFuncionalidades, funcionalidadId])
      e.target.value = '' // Resetear el select
    }
  }

  const handleRemoveFuncionalidad = (funcionalidadId: number) => {
    onChange(selectedFuncionalidades.filter((id) => id !== funcionalidadId))
  }

  // Usar el cache para obtener las funcionalidades seleccionadas, así siempre se muestran
  const selectedFuncionalidadesData = selectedFuncionalidades
    .map((id) => funcionalidadesCache.get(id))
    .filter((func): func is Funcionalidad => func !== undefined)

  // Funcionalidades disponibles que no están seleccionadas
  const availableFuncionalidadesNotSelected = availableFuncionalidades.filter(
    (func) => !selectedFuncionalidades.includes(func.id)
  )

  return (
    <div className='mb-5'>
      <label className='fw-bold fs-6 mb-4'>
        <KTIcon iconName='abstract-38' className='fs-3 me-2' />
        Funcionalidades
      </label>

      {/* Funcionalidades Seleccionadas */}
      <div className='d-flex flex-wrap gap-2 mb-3'>
        {selectedFuncionalidadesData.length > 0 ? (
          selectedFuncionalidadesData.map((func) => (
            <span key={func.id} className='badge badge-light-info badge-lg'>
              <span className='me-2'>{func.nombre}</span>
              <button
                type='button'
                className='btn btn-icon btn-sm btn-active-light-info'
                onClick={() => handleRemoveFuncionalidad(func.id)}
                style={{padding: 0, width: '16px', height: '16px'}}
              >
                <KTIcon iconName='cross' className='fs-5' />
              </button>
            </span>
          ))
        ) : (
          <span className='text-muted fs-7'>No hay funcionalidades seleccionadas</span>
        )}
      </div>

      {/* Dropdown de Funcionalidades */}
      <select
        className='form-select form-select-solid'
        onChange={handleSelectFuncionalidad}
        disabled={loading || availableFuncionalidadesNotSelected.length === 0}
      >
        <option value=''>Seleccionar una funcionalidad para agregar...</option>
        {availableFuncionalidadesNotSelected.map((func) => (
          <option key={func.id} value={func.id}>
            {func.nombre} ({func.codigo})
          </option>
        ))}
      </select>

      <div className='form-text mt-2'>
        Selecciona una funcionalidad del dropdown para agregarla. Las funcionalidades seleccionadas
        aparecerán arriba.
      </div>
    </div>
  )
}

export default FuncionalidadesSelector
